module.exports = __webpack_public_path__ + "img/ic_promote.7713aa6b.png";